(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5505],{

/***/ 5341:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/future-proof-your-hospitality-supply-chain",
      function () {
        return __webpack_require__(7953);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9396);
/* harmony import */ var _codebuild_output_src1147248868_src_itmtb_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _codebuild_output_src1147248868_src_itmtb_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src1147248868_src_itmtb_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);







var Footer = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1608), __webpack_require__.e(5600)]).then(__webpack_require__.bind(__webpack_require__, 3193));
}, {
    ssr: false
});
var Navbar = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1608), __webpack_require__.e(2684), __webpack_require__.e(7804), __webpack_require__.e(538)]).then(__webpack_require__.bind(__webpack_require__, 7804));
}, {
    ssr: false
});





var DownloadResource = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
        name: "",
        email: "",
        phone: "",
        company: "",
        whitepaper_title: "Challenges Faced by Procurement Aggregators in India’s Hospitality Sector",
        whitepaper_url: "https://www.itmtb.com/blog/whitepaper/challenges-faced-by-procurement-aggregators-in-india-hospitality-sector"
    }), formData = ref[0], setFormData = ref[1];
    var handleChange = function(e) {
        setFormData((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, formData), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, e.target.name, e.target.value)));
    };
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(""), message = ref1[0], setMessage = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isSubmitting = ref2[0], setIsSubmitting = ref2[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var handleSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_codebuild_output_src1147248868_src_itmtb_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(e) {
            var payload, res;
            return _codebuild_output_src1147248868_src_itmtb_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        if (!(!formData.name || !formData.email || !formData.phone || !formData.company)) {
                            _ctx.next = 4;
                            break;
                        }
                        setMessage("Please fill in all fields");
                        return _ctx.abrupt("return");
                    case 4:
                        setIsSubmitting(true);
                        payload = {
                            name: "".concat(formData.name),
                            email: formData.email,
                            phone: formData.phone,
                            company: formData.company,
                            whitepaper_title: formData.whitepaper_title,
                            whitepaper_url: formData.whitepaper_url
                        };
                        _ctx.prev = 6;
                        _ctx.next = 9;
                        return axios__WEBPACK_IMPORTED_MODULE_5___default().post("https://iyezxg6psa.execute-api.ap-south-1.amazonaws.com/default/live_itmtb_whitepaper_prospect", payload);
                    case 9:
                        res = _ctx.sent;
                        if (!res.data) {
                            _ctx.next = 18;
                            break;
                        }
                        _ctx.next = 13;
                        return axios__WEBPACK_IMPORTED_MODULE_5___default().post("https://650dkyt87l.execute-api.ap-south-1.amazonaws.com/default/live_itmtb_whitepaper_send_url", {
                            name: payload.name,
                            email: payload.email,
                            whitepaper_url: payload.whitepaper_url,
                            whitepaper_title: payload.whitepaper_title
                        });
                    case 13:
                        setMessage("Submitted successfully!");
                        alert("Redirecting to White Paper...");
                        router.push("/blog/whitepaper/challenges-faced-by-procurement-aggregators-in-india-hospitality-sector");
                        _ctx.next = 19;
                        break;
                    case 18:
                        {
                            setMessage("Submission failed. Please try again.");
                        }
                    case 19:
                        _ctx.next = 25;
                        break;
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t0 = _ctx["catch"](6);
                        console.error("Error submitting form: ", _ctx.t0);
                        setMessage("Submission failed.");
                    case 25:
                        _ctx.prev = 25;
                        setIsSubmitting(false);
                        return _ctx.finish(25);
                    case 28:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    6,
                    21,
                    25,
                    28
                ]
            ]);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Navbar, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "mt-16 flex flex-col md:flex-row sm:px-20 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "text-gray-700 sm:w-1/2 p-6 sm:px-12",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "flex flex-col gap-6 w-full",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                                    className: "sm:text-4xl text-3xl font-medium",
                                    children: "Tech-Driven Solutions for Hospitality Procurement: Overcoming Vendor Challenges"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                                    className: "text-2xl font-normal",
                                    children: "How procurement aggregators turn vendor relationships into strategic assets, achieving 98% fulfillment—even with India’s smallest suppliers?"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {
                                    className: "md:block hidden"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                    className: "text-lg font-light md:block hidden",
                                    children: "While competitors explain stockouts to disappointed guests, elite hospitality leaders have transformed fragile supply chains into powerful competitive advantages amid India's crippling ₹10.7 lakh crore payment crisis."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                    className: "text-lg font-light md:block hidden",
                                    children: [
                                        "This exclusive whitepaper unveils how innovative procurement aggregators achieve the impossible: 98% fulfillment from previously unreliable vendors.",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                    className: "text-lg font-normal md:block hidden",
                                    children: "Inside, discover:"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("ol", {
                                    className: "list-disc text-lg font-light ml-4 md:block hidden",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                            children: "Taj's strategy ensures seafood year-round despite monsoons"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                            children: "Zomato Hyperpure's zero-capital method for securing exceptional ingredients"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                            children: "The payment timing shift that turns struggling vendors into loyal partners"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                            children: "Marriott's proprietary system that virtually eliminates stockouts"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                            children: "The contractual framework that revolutionizes small vendor compliance"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                    className: "text-lg font-light md:block hidden",
                                    children: "As payment delays disrupt operations nationwide, this whitepaper offers a blueprint to move from reactive firefighting to strategic supply chain mastery."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                    className: "text-lg font-light md:block hidden",
                                    children: "The question isn't whether you'll face vendor defaults—it's whether you'll have systems to prevent them from affecting your customers."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "sm:w-1/2 mt-10 border rounded-xl overflow-hidden max-h-fit bg-white",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: "/blogImages/hero/alex-wong-l5Tzv1alcps-unsplash.webp",
                                width: 600,
                                height: 300,
                                className: "",
                                alt: "Future-Proof Your Hospitality Supply Chain"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                                className: "space-y-6 text-gray-700 px-12 my-12",
                                onSubmit: handleSubmit,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                                        className: "text-2xl font-medium",
                                        children: "Get Access to Complete White Paper"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                                className: "block font-normal",
                                                children: "Full name*"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                type: "text",
                                                name: "name",
                                                className: "w-full border p-2 rounded bg-white outline-none",
                                                value: formData.name,
                                                onChange: handleChange,
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                                className: "block font-normal",
                                                children: "Email*"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                type: "email",
                                                name: "email",
                                                className: "w-full border p-2 rounded bg-white outline-none",
                                                value: formData.email,
                                                onChange: handleChange,
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                                className: "block font-normal",
                                                children: "Organization name*"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                type: "text",
                                                name: "company",
                                                className: "w-full border p-2 rounded bg-white outline-none",
                                                value: formData.company,
                                                onChange: handleChange,
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                                className: "block font-normal",
                                                children: "Phone number*"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                type: "tel",
                                                name: "phone",
                                                pattern: "[0-9]{10}",
                                                className: "w-full border p-2 rounded bg-white outline-none",
                                                value: formData.phone,
                                                onChange: handleChange,
                                                required: true
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                className: "font-light text-sm mt-1",
                                                children: [
                                                    "By submitting this form, you agree to the",
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                                                        href: "/privacy_policy.html",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                            className: "underline cursor-pointer",
                                                            children: "Privacy Policy"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "flex flex-col justify-end ",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                            type: "submit",
                                            className: "px-4 py-2 bg-[#f1aa4e] text-white rounded hover:bg-[#f5a236] transition-all duration-300",
                                            disabled: isSubmitting,
                                            children: isSubmitting ? "Submitting" : "Submit"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Footer, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (DownloadResource);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,7692,9774,2888,179], function() { return __webpack_exec__(5341); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);